// @ts-strict-ignore
import { Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  availability: {
    textTransform: 'uppercase',
    padding: theme.spacing(1),
    width: 150,
    textAlign: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.2s ease',
  },
  available_now: {
    border: `1px solid ${theme.palette.success.main}`,
    color: theme.palette.success.main,
    '&:not($disabled):hover': {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.common.white,
    },
  },
  available_soon: {
    border: '1px solid #F5A623',
    color: '#F5A623',
    '&:not($disabled):hover': {
      backgroundColor: '#F5A623',
      color: theme.palette.common.white,
    },
  },
  not_available: {
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.error.main,
    '&:not($disabled):hover': {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white,
    },
  },
  working: {
    border: `1px solid ${theme.palette.secondary[500]}`,
    color: theme.palette.secondary[500],
    '&:not($disabled):hover': {
      backgroundColor: theme.palette.secondary[500],
      color: theme.palette.common.white,
    },
  },
  disabled: {
    opacity: 0.5,
    border: `1px solid ${theme.palette.grey[400]}`,
    color: theme.palette.grey[400],
  },
}))

interface IAvailabilityChipProps {
  availability: string
  current: string
  onClick?: (value: any) => void
}

const AvailabilityChip: React.FC<IAvailabilityChipProps> = ({ availability, current, onClick }) => {
  const { classes, cx } = useStyles()

  const label = (avail) => {
    return {
      available_now: 'available now',
      available_soon: 'available soon',
      not_available: 'not available',
      working: 'working',
    }[avail]
  }

  const className = cx(
    classes.availability,
    classes[availability],
    current !== availability && classes.disabled,
  )

  const handleClick = (event) => {
    if (onClick) {
      onClick(event)
    }
  }

  return (
    <Typography
      variant="body2"
      className={className}
      onClick={handleClick}
      data-cy="availability-chip"
      role="button"
    >
      {label(availability)}
    </Typography>
  )
}

export default AvailabilityChip
